/*
 * Es este archivo solo debe contener mappers de request/response para el consumo de las API.
 * Otros tipos de mapeos deberían ir en mappers.ts
 * Las funciones (que se exportan) deben tener el sufijo "RequestMap" o "ResponseMap" según corresponda
 */
import { format, parse, parseISO } from 'date-fns';
import {
  FindConciliationDetailResponse,
  FindConciliationHeaderResponse,
  GetActiveCountriesResponse,
  GetActiveStoresResponse,
  GetParametersResponse,
  FindConciliationHeaderRequest,
  FindConciliationDetailRequest,
  FindConciliationsStatusRequest,
  FindMastersStatusResponse,
  FindSovosStatusResponse,
  FindMastersImportResponse,
  FindMastersImportRequest,
  MastersImportRequest,
  FindFiscalDetailRequest,
  FindFiscalDetailResponse,
  FindSovosImportRequest,
  FindReprocessRequest,
  CreateReprocessRequest,
  CreateReprocessSalesPARequest,
  CreateReprocessEmiteMXRequest,
  FindReprocessResponse,
  FindReprocessParametersResponse,
  FindDashboardTotalsByCountryRequest,
  FindClosureEvolutionRequest,
  GetOpStructuresResponse,
} from '../services';

import {
  Agreement,
  AppParameters,
  ConciliationDetail,
  ConciliationDetailErrors,
  ConciliationHeader,
  ConciliationHeaderState,
  FranchiseType,
  Country,
  FindConciliationsStatusResponse,
  ConciliationStatus,
  Management,
  MasterData,
  OpStructures,
  PodOptionType,
  Region,
  RegionalManagement,
  ReportFilter,
  Stores,
  Supervision,
  ConciliationHeaderId,
  MastersStatus,
  SovosImportStatus,
  FiscalDetail,
  FiscalDetailFilter,
  MastersImport,
  MastersImportDetailFilter,
  MasterImportExecutionForm,
  ReprocessFilter,
  CreateReprocessForm,
  Reprocess,
  ReprocessParameters,
  DashboardTotalsByCountry,
  Company,
  OpStructuresFilter,
} from '../types';

import { masterSort, undefinedIfEmpty } from './utls';

export const dateRequestMap = (date: Date | null | undefined) =>
  date ? format(date, 'yyyy-MM-dd') : undefined;

export const dateRangeRequestMap = (from: Date | null | undefined, to: Date | null | undefined) => {
  if (!from && !to) return undefined;
  const fromStr = from ? format(from, 'yyyy-MM-dd') : '';
  const toStr = to ? format(to, 'yyyy-MM-dd') : '';
  return `${fromStr},${toStr}`;
};

export const dateResponseMap = (date: string | null | undefined) => {
  if (!date) return undefined;

  const parsedDate = parse(date, 'yyyy-MM-dd', new Date());

  return parsedDate;
};

export const dateTimeResponseMap = (date: string | null | undefined) =>
  date ? parseISO(date) : undefined;

export const podRequestMap = (pod: PodOptionType[]): string | undefined => {
  if (pod.length === 1) return pod[0] as string;
  return undefined;
};

export const masterDataResponseMap = (
  opStructuresResponse: GetOpStructuresResponse,
  // posTypesResponse: GetPosTypesResponse,
  // federativeEntitiesResponse: Record<string, string[]>,
  stores: GetActiveStoresResponse
): MasterData => {
  const opStructuresMap = (opStructuresResponse: GetOpStructuresResponse): OpStructures => {
    const opStructures = opStructuresResponse.map(i => ({
      divisionId: i.division_id,
      division: i.division,
      countryId: i.country_id,
      country: i.country,
      regionalMgmtId: i.regional_mgmt_id,
      regionalMgmt: i.regional_mgmt,
      regionId: i.region_id,
      region: i.region,
      mgmtId: i.mgmt_id,
      mgmt: i.mgmt,
      supervisionId: i.supervision_id,
      supervision: i.supervision,
      storeEntityId: i.store_entity_id,
      storeAcronym: i.store_acronym,
      companyId: i.company_id,
      companyName: i.company_name,
      agreementId: i.agreement_id,
      agreementType: i.agreement_type,
    }));
    return opStructures;
  };

  const opStructures = opStructuresMap(opStructuresResponse);

  const countryMap = (item: GetOpStructuresResponse[0]): Country => ({
    id: item.country_id.toString(),
    label: item.country,
    countryCode: item.country,
    countryId: item.country_id.toString(),
    divisionId: item.division_id,
    divisionName: item.division,
  });

  const companyMap = (item: GetOpStructuresResponse[0], countries: Country[]): Company => ({
    countries: countries.some(i => i.countryCode === item.country)
      ? countries
      : [...countries, countryMap(item)],
    companyId: item.company_id,
    companyName: item.company_name,
  });

  // const storeMap = (item: GetOpStructuresResponse[0]): Stores => ({
  //   ...countryMap(item),
  //   agreementType: item.agreement_type,
  //   agreementId: item.agreement_id,
  //   companyName: item.company_name,
  //   companyId: item.company_id,
  //   regionalMgmt: item.regional_mgmt,
  //   regionalMgmtId: item.regional_mgmt_id,
  //   region: item.region,
  //   regionId: item.region_id,
  //   mgmtId: item.mgmt_id,
  //   mgmt: item.mgmt,
  //   supervisionId: item.supervision_id,
  //   supervision: item.supervision,
  //   storeId: item.store_entity_id,
  //   storeAcronym: item.store_acronym,
  // });

  // const storeMap = (response: any[]): Stores[] =>
  //   response.map(i => ({
  //     oakStoreId: i.oak_store_id,
  //     countryDescription: i.country_description,
  //     storeId: i.store_id,
  //     costCenter: i.cost_center,
  //     createdDate: i.created_date,
  //     brBaseStoreId: i.br_base_store_id,
  //     closeDate: i.close_date,
  //     brFranchiseInd: i.br_franchise_ind,
  //     countryCode: i.country,
  //     storeMoreModifyDate: i.store_more_modify_date,
  //     name: i.name,
  //     groupId: i.group_id,
  //     estadoSgl: i.estado_sgl,
  //     openDate: i.open_date,
  //     postalCode: i.postal_code,
  //     city: i.city,
  //     stateProvince: i.state_province,
  //     cidadeId: i.cidade_id,
  //     addressLine1: i.address_line_1,
  //     storeModifyDate: i.store_modify_date,
  //     mailUser: i.mail_user,
  //     countryId: i.country_id,
  //     phone: i.phone,
  //     storeAcronym: i.storeAcronym,
  //   }));

  const storeMap = (
    response: GetActiveStoresResponse,
    opStructuresResponse: GetOpStructuresResponse
  ): Stores[] => {
    const opStructureByStore = new Map(
      opStructuresResponse.map(item => [item.store_acronym, item])
    );

    return response.map(i => {
      const opStructure = opStructureByStore.get(i.storeAcronym);

      return {
        oakStoreId: i.oak_store_id,
        countryDescription: i.country_description,
        storeId: i.store_id,
        costCenter: i.cost_center,
        createdDate: i.created_date,
        brBaseStoreId: i.br_base_store_id,
        closeDate: i.close_date,
        brFranchiseInd: i.br_franchise_ind,
        countryCode: i.country,
        storeMoreModifyDate: i.store_more_modify_date,
        name: i.name,
        groupId: i.group_id,
        estadoSgl: i.estado_sgl,
        openDate: i.open_date,
        postalCode: i.postal_code,
        city: i.city,
        stateProvince: i.state_province,
        cidadeId: i.cidade_id,
        addressLine1: i.address_line_1,
        storeModifyDate: i.store_modify_date,
        mailUser: i.mail_user,
        countryId: i.country_id,
        phone: i.phone,
        storeAcronym: i.storeAcronym,

        country: opStructure?.country ?? i.country,
        agreementType: opStructure?.agreement_type ?? '',
        agreementId: String(opStructure?.agreement_id ?? ''),
        companyId: String(opStructure?.company_id ?? ''),
        companyName: opStructure?.company_name ?? '',
        regionalMgmt: opStructure?.regional_mgmt ?? '',
        regionalMgmtId: String(opStructure?.regional_mgmt_id ?? ''),
        region: opStructure?.region ?? '',
        regionId: String(opStructure?.region_id ?? ''),
        mgmt: opStructure?.mgmt ?? '',
        mgmtId: String(opStructure?.mgmt_id ?? ''),
        supervision: opStructure?.supervision ?? '',
        supervisionId: String(opStructure?.supervision_id ?? ''),
        divisionId: opStructure?.division_id ?? '',
        divisionName: opStructure?.division ?? '',
      };
    });
  };
  // const mappedStores = storeMap(stores, opStructuresResponse);
  // const posTypeMap = (item: GetPosTypesResponse[0]): PosType => ({
  //   segmentDesc: item.segment_description,
  //   segmentId: item.segment_id,
  // });

  // const values = opStructuresResponse.reduce(
  //   (prev, curr) => ({
  //     divisions: [...prev.divisions, curr.division_id],
  //     countries: {
  //       ...prev.countries,
  //       [curr.country_id]: countryMap(curr),
  //     },
  //     stores: [...prev.stores, storeMap(curr)],
  //     companies: {
  //       ...prev.companies,
  //       [curr.company_id]: companyMap(curr, prev.companies[curr.company_id]?.countries || []),
  //     },
  //   }),
  //   {
  //     countries: {} as Record<string, Country>,
  //     divisions: [] as string[],
  //     stores: [] as Stores[],
  //     companies: {} as Record<number, Company>,
  //   }
  // );
  const values = opStructuresResponse.reduce(
    (prev, curr) => ({
      divisions: [...prev.divisions, curr.division_id],
      countries: {
        ...prev.countries,
        [curr.country_id]: countryMap(curr),
      },
      companies: {
        ...prev.companies,
        [String(curr.company_id)]: companyMap(
          curr,
          prev.companies[String(curr.company_id)]?.countries || []
        ),
      },
    }),
    {
      countries: {} as Record<string, Country>,
      divisions: [] as string[],
      companies: {} as Record<string, Company>,
    }
  );

  const getRegionalManagements = (opStructures: OpStructures): RegionalManagement[] => {
    const regionalManagements: RegionalManagement[] = [];
    opStructures.forEach(({ countryId, ...i }) => {
      if (
        regionalManagements.findIndex(item => item.id === i.regionalMgmtId) === -1 &&
        i.regionalMgmtId !== null &&
        i.regionalMgmt !== null
      ) {
        regionalManagements.push({
          label: i.regionalMgmt,
          id: i.regionalMgmtId,
          divisionName: i.division,
          countryCode: i.country,
          countryId: countryId.toString(),
          regionalMgmt: i.regionalMgmt,
          regionalMgmtId: i.regionalMgmtId,
          divisionId: i.divisionId,
        });
      }
    });
    return regionalManagements;
  };

  const getRegions = (opStructures: OpStructures): Region[] => {
    const regions: Region[] = [];
    opStructures.forEach(({ countryId, ...i }) => {
      if (
        regions.findIndex(r => r.id === i.regionId) === -1 &&
        i.regionId !== null &&
        i.region !== null
      ) {
        regions.push({
          label: i.region,
          id: i.regionId,
          divisionName: i.division,
          countryCode: i.country,
          countryId: countryId.toString(),
          regionId: i.regionId,
          regionalMgmt: i.regionalMgmt,
          regionalMgmtId: i.regionalMgmtId,
          divisionId: i.divisionId,
          region: i.region,
        });
      }
    });
    return regions;
  };

  const getManagements = (opStructures: OpStructures): Management[] => {
    const managements: Management[] = [];
    opStructures.forEach(({ countryId, ...i }) => {
      if (
        managements.findIndex(m => m.id === i.mgmtId) === -1 &&
        i.mgmtId !== null &&
        i.mgmt !== null
      ) {
        managements.push({
          label: i.mgmt,
          id: i.mgmtId,
          divisionName: i.division,
          countryCode: i.country,
          countryId: countryId.toString(),
          mgmtId: i.mgmtId,
          mgmt: i.mgmt,
          region: i.region,
          regionId: i.regionId,
          regionalMgmt: i.regionalMgmt,
          regionalMgmtId: i.regionalMgmtId,
          divisionId: i.divisionId,
        });
      }
    });
    return managements;
  };

  const getSupervisions = (opStructures: OpStructures): Supervision[] => {
    const supervisions: Supervision[] = [];
    opStructures.forEach(({ countryId, ...i }) => {
      if (
        supervisions.findIndex(s => s.id === i.supervisionId) === -1 &&
        i.supervisionId !== null &&
        i.supervision !== null
      ) {
        supervisions.push({
          label: i.supervision,
          id: i.supervisionId,
          divisionName: i.division,
          countryCode: i.country,
          countryId: countryId.toString(),
          supervision: i.supervision,
          supervisionId: i.supervisionId,
          mgmtId: i.mgmtId,
          mgmt: i.mgmt,
          regionId: i.regionId,
          region: i.region,
          regionalMgmt: i.regionalMgmt,
          regionalMgmtId: i.regionalMgmtId,
          divisionId: i.divisionId,
        });
      }
    });
    return supervisions;
  };

  const getAgreements = (opStructures: OpStructures): Agreement[] => {
    const agreements: Agreement[] = [];
    opStructures.forEach(({ countryId, ...i }) => {
      if (
        agreements.findIndex(a => a.id === i.agreementId) === -1 &&
        i.agreementId !== null &&
        i.agreementType !== null
      ) {
        agreements.push({
          label: i.agreementId !== null ? i.agreementType : 'null',
          id: i.agreementId,
          divisionName: i.division,
          countryCode: i.country,
          countryId: countryId.toString(),
          agreementId: i.agreementId,
          agreementType: i.agreementType,
          divisionId: i.divisionId,
        });
      }
    });
    return agreements;
  };

  // Construye opciones para todos los países:
  // - Para Brasil usa estado_sgl (tiene el código corto: "SP", "RJ")
  // - Para el resto usa state_province (tiene el nombre: "Estado de México", "Pichincha")
  const federativeEntitiesResponse = stores.reduce((acc, i) => {
    const stateValue = i.estado_sgl || i.state_province;
    if (!stateValue) return acc;
    if (!acc[i.country]) acc[i.country] = [];
    if (!acc[i.country].includes(stateValue)) acc[i.country].push(stateValue);
    return acc;
  }, {} as Record<string, string[]>);
  const mappedStores = storeMap(stores, opStructuresResponse);
  const countries = mappedStores.map(i => ({
    countryId: i.countryId,
    countryCode: i.countryCode,
  })) as Country[];

  // const result: MasterData = ;

  return {
    divisions: [...new Set(values.divisions)],
    countries: Object.values(values.countries),
    stores: mappedStores, // values.stores,
    posTypes: [], // posTypesResponse.map(posTypeMap),
    companies: Object.values(values.companies),
    regionalManagements: getRegionalManagements(opStructures),
    regions: getRegions(opStructures),
    managements: getManagements(opStructures),
    supervisions: getSupervisions(opStructures),
    agreements: getAgreements(opStructures),
    federativeEntities: federativeEntitiesResponse,
  };
};

export const findMastersImportRequestMap = (
  filters: MastersImportDetailFilter
): FindMastersImportRequest => ({
  countries: undefinedIfEmpty(filters.countries.map(i => i.countryId).join()),
  importDateRange: dateRangeRequestMap(
    filters.startImportDate.accept,
    filters.endImportDate.accept
  ),
  state: undefinedIfEmpty(filters.state.join()),
});

export const findMastersImportResponseMap = (
  response: FindMastersImportResponse,
  countries: Country[]
): MastersImport[] =>
  response
    .map(i => ({
      importDate: dateResponseMap(i.import_date) as Date,
      type: i.type,
      country: countries.find(c => c.countryId === i.id)?.countryCode || i.id,
      description: i.description,
      quantity: i.quantity,
      state: i.state,
    }))
    .sort(masterSort);

export const findMastersImportExecutionRequestMap = (
  request: MasterImportExecutionForm
): MastersImportRequest => ({
  master_type: request.mastersTypes,
  countries: request.countries?.map(i => i.countryId).join(','),
  days: request.days,
  only_active: true,
});

export const findSovosStatusResponseMap = (
  response: FindSovosStatusResponse
): SovosImportStatus[] =>
  response.map(i => ({
    importDate: i.import_date,
    country: i.country,
    status: i.status,
    totalTickets: i.total_tickets,
    amount: i.amount,
  }));

export const findFiscalDetailRequestMap = (
  filters: FiscalDetailFilter,
  countries: string[]
): FindFiscalDetailRequest => ({
  countries: undefinedIfEmpty(countries.join()),
  stores: filters.stores.map(store => store.storeAcronym).join(','),
  authorizationDateRange: dateRangeRequestMap(filters.startDate.accept, filters.endDate.accept),
});

export const findFiscalDetailResponseMap = (response: FindFiscalDetailResponse): FiscalDetail[] =>
  response
    .map(i => ({
      authorizationDate: dateResponseMap(i.authorization_date) as Date,
      country: i.country,
      store: i.store,
      fiscalId: i.fiscal_id,
      model: i.model,
      status: i.status || '',
      registry_qty: i.registry_qty,
    }))
    .sort(
      (first, second) => first.authorizationDate.getTime() - second.authorizationDate.getTime()
    );
// .sort();  masterSort (anterior)

export const findMastersStatusResponseMap = (
  response: FindMastersStatusResponse
): MastersStatus[] =>
  response.map(i => ({ importDate: dateResponseMap(i.import_date) as Date, status: i.status }));

export const activeCountriesResponseMap = (response: GetActiveCountriesResponse): Country[] =>
  response.map(i => ({
    id: i.country_id,
    label: i.country,
    divisionId: i.division_id || '',
    divisionName: i.division || '',
    countryId: i.country_id,
    countryCode: i.country,
  }));

export const findConciliationsStatusRequestMap = (
  fromDt: Date,
  toDt: Date,
  countries: string[]
): FindConciliationsStatusRequest => ({
  countryAcronym: countries.join(),
  accountingDateRange: dateRangeRequestMap(fromDt, toDt) as string,
});

export const findSovosImportRequestMap = (countries: string[]): FindSovosImportRequest => ({
  countryAcronym: countries.join(),
});

export const findConciliationDetailResponseMap = (
  response: FindConciliationDetailResponse[]
): ConciliationDetail[] =>
  response.map(item => ({
    fiscalId: item.fiscal_id,
    country: item.country,
    store: item.store,
    accountingDate: dateResponseMap(item.accounting_date) as Date,
    fiscalKey: item.fiscal_key,
    posNum: item.pos_num,
    error: item.error,
    transactionTypeFv: item.transaction_type_fv,
    discountOnTotalAmtFv: item.discount_on_total_amt_fv,
    transactionAmtFv: item.transaction_amt_fv,
    transactionTypeFs: item.transaction_type_fs,
    discountOnTotalAmtFs: item.discount_on_total_amt_fs,
    transactionAmtFs: item.transaction_amt_fs,
    xjust: item.xjust,
    businessDateFv: item.business_date_fv,
    qtySalesFv: item.qty_sales_fv,
    qtySalesFs: item.qty_sales_fs,
    GCs: item.GCs,
  }));

export const findConciliationDetailRequestMap = (
  filters: ReportFilter,
  errorsFilter: ConciliationDetailErrors[],
  conciliationHeaderId: ConciliationHeaderId,
  sentToOnedrive: boolean,
  opStructures: {
    regionalMgmt: RegionalManagement[];
    region: Region[];
    management: Management[];
    supervision: Supervision[];
    company: Company[];
    agreement: Agreement[];
  }
): FindConciliationDetailRequest => ({
  countryAcronym: filters.countryCode,
  storeAcronym: undefinedIfEmpty(
    filters.conciliationDetailFilters.stores.map(i => i.storeAcronym).join()
  ),
  accountingDateRange: dateRangeRequestMap(
    filters.conciliationDetailFilters.startDate.accept,
    filters.conciliationDetailFilters.endDate.accept
  ),
  errors: undefinedIfEmpty(errorsFilter.join()),
  pos: undefinedIfEmpty((filters.pos ?? []).join()),
  conciliationHeaderId: undefinedIfEmpty(conciliationHeaderId),
  sentToOnedrive,

  regionalMgmtId: undefinedIfEmpty(opStructures.regionalMgmt.map(i => i.regionalMgmtId).join()),
  regionId: undefinedIfEmpty(opStructures.region.map(i => i.regionId).join()),
  mgmtId: undefinedIfEmpty(opStructures.management.map(i => i.mgmtId).join()),
  supervisionId: undefinedIfEmpty(opStructures.supervision.map(i => i.supervisionId).join()),
  companyId: undefinedIfEmpty(opStructures.company.map(i => i.companyId).join()),
  agreementId: undefinedIfEmpty(opStructures.agreement.map(i => i.agreementId).join()),
});

export const findConciliationHeaderResponseMap = (
  response: FindConciliationHeaderResponse[]
): ConciliationHeader[] =>
  response.map(item => ({
    conciliationHeaderId: item.conciliation_header_id,
    country: item.country,
    store: item.store,
    accountingDate: dateResponseMap(item.accounting_date) as Date,
    status: item.state,
    gcs: item.gcs,
    gcsFs: item.gcs_fs,
    gcsOk: item.gcs_ok,
    gcsDif: item.gcs_dif,
    gcsFv: item.gcs_fv,
    gcsFiscal: item.gcs_fiscal,
    totalAmt: item.total_amt,
    totalAmtFs: Number(item.total_amt_fs),
    totalAmtOk: item.total_amt_ok,
    totalAmtDif: item.total_amt_dif,
    totalAmtFv: item.total_amt_fv,
    totalAmtFiscal: Number(item.total_amt_fiscal),
    porcOk: item.porc_ok,
    qtyCancSust: item.qty_canc_sust,
    totalAmtCancSust: item.total_amt_canc_sust,
  }));

export const findConciliationHeaderRequestMap = (
  filters: ReportFilter,
  stateSelected: ConciliationHeaderState[],
  franchiseTypes: FranchiseType[],
  federativeEntities: string[],
  sentToOnedrive: boolean,
  opStructures: {
    regionalMgmt: RegionalManagement[];
    region: Region[];
    management: Management[];
    supervision: Supervision[];
    company: Company[];
    agreement: Agreement[];
  }
): FindConciliationHeaderRequest => ({
  countryAcronym: filters.countryCode,
  storeAcronym: undefinedIfEmpty(filters.stores.map(i => i.storeAcronym).join()),
  accountingDateRange: dateRangeRequestMap(
    filters.startAccountingDate.accept,
    filters.endAccountingDate.accept
  ),
  status: undefinedIfEmpty(stateSelected.join()),
  franchiseTypes: undefinedIfEmpty(franchiseTypes.join()),
  federativeEntities: undefinedIfEmpty(federativeEntities.join()),
  sentToOnedrive,
  regionalMgmtId: undefinedIfEmpty(opStructures.regionalMgmt.map(i => i.regionalMgmtId).join()),
  regionId: undefinedIfEmpty(opStructures.region.map(i => i.regionId).join()),
  mgmtId: undefinedIfEmpty(opStructures.management.map(i => i.mgmtId).join()),
  supervisionId: undefinedIfEmpty(opStructures.supervision.map(i => i.supervisionId).join()),
  companyId: undefinedIfEmpty(opStructures.company.map(i => i.companyId).join()),
  agreementId: undefinedIfEmpty(opStructures.agreement.map(i => i.agreementId).join()),
});

export const findDashboardConciliationsStateResponseMap = (
  response: FindConciliationsStatusResponse[]
): ConciliationStatus[] =>
  response.map(i => ({
    country: i.country,
    endDate: dateResponseMap(i.end_date) as Date,
    startDate: dateResponseMap(i.start_date) as Date,
    closuresReceived: Number(i.closures_received),
    conciliationOk: Number(i.conciliation_ok),
    numberOfRestaurants: Number(i.number_of_restaurants),
  }));

export const filterParametersResponseMap = (response: GetParametersResponse): AppParameters => ({
  filtersLimitMonths: 10,
  dashboardTimer: 10,
  statuses: response?.statuses,
  errors: response?.errors,
  reportLimits: response?.reportLimits,
  countriesRules: {
    definitions:
      response.countries_rules?.definitions.map((r: any) => ({
        id: r.id,
        code: r.code,
        description: r.description,
      })) || [],
    assignments: response.countries_rules?.assignments || {},
    conciliationMethods: response.countries_rules?.conciliationMethods || {},
  },
});

export const findReprocessRequestMap = (filters: ReprocessFilter): FindReprocessRequest => ({
  countryAcronym: filters.countryCode,
  reprocessType: filters.reprocessType,
  status: filters.status,
  storeAcronym: filters.storeAcronym,
  federativeEntity: filters.federativeEntity,
  businessDate: dateRequestMap(filters.businessDate.accept),
});

export const createReprocessRequestMap = (
  request: CreateReprocessForm
): CreateReprocessRequest => ({
  countryAcronym: request.country || '',
  justification: request.justification,
  stores: request.store ? [request.store] : [],
  businessDateFrom: dateRequestMap(request.businessDateFrom) as string,
  businessDateTo: dateRequestMap(request.businessDateTo) as string,
});

export const createReprocessSalesPARequestMap = (
  request: CreateReprocessForm
): CreateReprocessSalesPARequest => ({
  countryAcronym: request.country || '',
  justification: request.justification,
  businessDateFrom: dateRequestMap(request.businessDateFrom) as string,
  businessDateTo: dateRequestMap(request.businessDateTo) as string,
});

export const createReprocessEmiteMXRequestMap = (
  request: CreateReprocessForm
): CreateReprocessEmiteMXRequest => ({
  countryAcronym: request.country || '',
  justification: request.justification,
  stores: request.store || '',
  businessDateFrom: dateRequestMap(request.businessDateFrom) as string,
  businessDateTo: dateRequestMap(request.businessDateTo) as string,
});

export const findReprocessResponseMap = (response: FindReprocessResponse): Reprocess[] =>
  response.map(i => ({
    country: i.country,
    justification: i.justification,
    status: i.status,
    store: i.store,
    type: i.reprocess_type,
    user: i.user,
    businessDate: dateResponseMap(i.business_date) as Date,
    executionDate: dateTimeResponseMap(i.execution_date) as Date,
    creationDate: dateTimeResponseMap(i.creation_date) as Date,
    federativeEntity: i.federative_entity || '',
  }));

export const findReprocessParametersResponseMap = (
  response: FindReprocessParametersResponse
): ReprocessParameters => ({
  statuses: response.statuses,
});

export const findDashboardTotalsByCountryRequestMap = (
  from: Date,
  to: Date,
  countryCodes: (string | undefined | null)[]
): FindDashboardTotalsByCountryRequest => ({
  countryAcronym: countryCodes.filter(Boolean).join(','),
  accountingDateRange: dateRangeRequestMap(from, to) as string,
});

export const findDashboardTotalsByCountryResponseMap = (
  data: {
    country: string;
    flex_amount: number;
    flex_gcs: number;
    sovos_amount: number;
    sovos_gcs: number;
  }[]
): DashboardTotalsByCountry[] =>
  data.map(r => ({
    country: r.country,
    flex: { amount: r.flex_amount ?? 0, gcs: r.flex_gcs ?? 0 },
    sovos: { amount: r.sovos_amount ?? 0, gcs: r.sovos_gcs ?? 0 },
  }));
export const findClosureEvolutionRequestMap = (
  fromDt: Date,
  toDt: Date,
  countries: string[],
  stores?: string[]
): FindClosureEvolutionRequest => {
  const storeCsv = (stores ?? []).filter(Boolean).join();

  return {
    countryAcronym: countries.join(),
    ...(storeCsv ? { storeAcronym: storeCsv } : {}), // si tu backend soporta storeAcronym como CSV
    accountingDateRange: dateRangeRequestMap(fromDt, toDt) as string,
  };
};
